// 택배 API 문서 카테고리
import getV10APIs from './v1.0';
import { mergeVersionsByTitle } from '../../../util/HelperFunctions';

const data = (userInfo) => {
  const v10APIs = getV10APIs(userInfo);

  const children = [
    mergeVersionsByTitle('택배사 등록', v10APIs),
    mergeVersionsByTitle('송장발번', v10APIs),
    mergeVersionsByTitle('배송추적 조회', v10APIs),
  ].filter(Boolean);

  return { title: '택배', children };
};

export default data;
